// React js component
import { useEffect, useState } from "react";

const AnimatedNumber = ({
  value = 0,
  duration = 1500,
  prefix = "",
  suffix = "",
  decimals = 0,
  separator = true,
}) => {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    const targetValue = Number(value) || 0;
    const startValue = 0;

    if (targetValue === 0) {
      setDisplayValue(0);
      return;
    }

    let startTime = null;
    let animationFrame;

    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;

      const progress = Math.min((currentTime - startTime) / duration, 1);

      // Ease-out animation
      const easedProgress = 1 - Math.pow(1 - progress, 3);

      const currentValue =
        startValue + (targetValue - startValue) * easedProgress;

      setDisplayValue(currentValue);

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => {
      cancelAnimationFrame(animationFrame);
    };
  }, [value, duration]);

  const formattedValue = displayValue.toLocaleString("en-IN", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
    useGrouping: separator,
  });

  return (
    <span>
      {prefix}
      {formattedValue}
      {suffix}
    </span>
  );
};

export default AnimatedNumber;
